module.exports = __webpack_public_path__ + "363b30b9b0b6b4fba3e6f478d28878fc.svg";